module.exports = __webpack_public_path__ + "static/media/female-teacher_1f469-200d-1f3eb.b9ebbe2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/female-teacher_1f469-200d-1f3eb.png
// module id = 726
// module chunks = 2